





















































import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { Component, Vue } from "vue-property-decorator";
import Galery from "@/components/Galery.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Galery,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class InfographyFundamental extends Vue {
  protected galeryInfographyFundamental: string[] = [
    "picture_Infography/fundamental_infography.png",
    "picture_Infography/fundamental_infography2.jpg",
  ];
  protected nxtprevInfographyFundamental = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail6.png",
    PrevLink: "",
    NextLink: "/Infographie/Astuces",
  };
}
